import React from "react";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import CaretDownIcon from "../../SVGs/CaretDown";
import { DropdownContentLayout } from "./DropdownContentLayout";
import FeaturesHeader from "./FeaturesHeader";
import { useNavMenuHooks } from "../utils/useNavMenuHook";
import MenuItemList from "../NavMenuContents/MenuItemList";
import { AnimatePresence } from "framer-motion";
import {
  NavLinkClickHandler,
  NavMenuDropdownProps,
} from "src/assets/Types/Redesign/PrimaryNavMenuType.type";
import useMediaQueries from "@hooks/useMediaQueries";

const FeaturesMenu: React.FC<NavMenuDropdownProps & NavLinkClickHandler> = ({
  categoryList,
  onClickHandler,
  ...rest
}) => {
  const { onMouseEnterHandler, isOpen, isShowDropdown } = useNavMenuHooks();

  const { isTouch } = useMediaQueries();

  return (
    <>
      <NavigationMenu.Trigger
        className="flex items-center justify-between group cursor-default bg-transparent px-0"
        onMouseEnter={onMouseEnterHandler}
        onClick={e => {
          if (!isTouch) {
            e.preventDefault();
          }
        }}
      >
        <p className="relative body--text-regular">
          <span className="block group-hover:opacity-0">Features</span>
          <span className="hidden font-semibold absolute top-0 left-0 -tracking-[0.3px] group-hover:inline">
            Features
          </span>
        </p>
        <CaretDownIcon
          className="ml-[11px] transition-transform duration-[200] ease-in group-data-[state=open]:rotate-180"
          aria-hidden
        />
      </NavigationMenu.Trigger>
      {isShowDropdown && (
        <DropdownContentLayout className="flex-col z-10">
          <AnimatePresence mode="wait" initial={false}>
            <div className="mx-auto flex flex-col gap-12 max-w-desktop w-full pb-14 font-sans">
              <FeaturesHeader {...rest} onClickHandler={onClickHandler} />
            </div>

            <div className="flex">
              {categoryList?.map((category, key) => (
                <MenuItemList
                  key={key}
                  category={category}
                  isOpen={isOpen}
                  onClickHandler={onClickHandler}
                  title="features"
                />
              ))}
            </div>
          </AnimatePresence>
        </DropdownContentLayout>
      )}
    </>
  );
};

export default FeaturesMenu;
